import { render, staticRenderFns } from "./DataFilterItem.vue?vue&type=template&id=35c3fdc8&scoped=true&"
import script from "./DataFilterItem.vue?vue&type=script&lang=js&"
export * from "./DataFilterItem.vue?vue&type=script&lang=js&"
import style0 from "./DataFilterItem.vue?vue&type=style&index=0&id=35c3fdc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c3fdc8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardSubtitle,VCardText,VChip,VChipGroup,VIcon,VTabItem,VTextField})
